import React, { useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from './ModalUnverifiedUser.module.scss';

import { Modal } from 'react-bootstrap';

import { withRouter } from 'react-router-dom';
import moment from 'moment';

import { IModalUnverifiedUserProps } from './ModalUnverifiedUser.d';

import UnverifiedImage from '../../../../../images/unverified-user.png';
import CloseIcon from '../../../../../images/round-close-button.png';
import VerifyImage from '../../../../../images/verify-email-sent.png';
import { connect } from 'react-redux';
import {
  doFetchProfile,
  doRefreshToken,
  doSentLinkVerificationEmail,
} from 'actions/authAction';

function ModalUnverifiedUser({
  isHome,
  type,
  isShow,
  setIsShow,
  doVerifyEmail,
  user,
  fetchProfile,
  refreshToken,
}: IModalUnverifiedUserProps) {
  const [status, setStatus] = useState<'info' | 'confirm'>('info');
  const handleCloseBanner = () => {
    setIsShow(false);
  };

  const verify = () => {
    if (!doVerifyEmail) return;
    doVerifyEmail().then(() => {
      setStatus('confirm');
    });
  };

  const alreadyVerified = () => {
    if (!fetchProfile) return;
    fetchProfile().then(() => {
      if (!refreshToken) return;
      refreshToken().then(() => {
        setIsShow(false);
        setStatus('info');
      });
    });
  };

  const renderModal = React.useCallback(() => {
    if (status === 'info') {
      return (
        <div className={Styles['wrapper']}>
          <KickImage
            className={Styles['unverified-image']}
            src={UnverifiedImage}
            alt="..."
          />
          <p className={Styles['title']}>Your email has not been verified</p>
          <p className={Styles['sub-title']}>
            {isHome
              ? 'Please verify your email to activate your account'
              : `Please verify your email to continue ${type}`}
          </p>
          <div className={Styles['button-wrapper']} onClick={verify}>
            <p className={Styles['button-text']}>Verify Now</p>
          </div>
        </div>
      );
    }

    return (
      <div className={Styles['wrapper']}>
        <KickImage
          className={Styles['unverified-image']}
          src={VerifyImage}
          alt="..."
        />
        <p className={Styles['title']}>Email verification sent</p>
        <p className={Styles['sub-title']}>
          We already sent a link to <b>{user?.email}</b>
        </p>
        <div className={Styles['button-wrapper']} onClick={verify}>
          <p className={Styles['button-text']}>Resend Email</p>
        </div>
        <div
          className={Styles['button-verified-wrapper']}
          onClick={alreadyVerified}
        >
          <p className={Styles['button-text']}>I'm Verified</p>
        </div>
        <div className={Styles['text-info']}>
          <p>
            Please check your inbox / junk / spam for an email from
            no-reply@kickavenue.com and click the verification link in it.
          </p>
        </div>
      </div>
    );
  }, [status, isHome, type]);

  return (
    <Modal
      show={isShow}
      id="modal-popup-banner"
      centered
      fullscreen={true}
      onHide={handleCloseBanner}
      className={Styles['modal-unverified-user']}
    >
      <KickImage
        onClick={handleCloseBanner}
        className={Styles['close-icon']}
        alt="close icon"
        src={CloseIcon}
      />
      {renderModal()}
    </Modal>
  );
}

const mapStateToProps = (state: any) => {
  return {
    user: state.dataAuth.userdata,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    doVerifyEmail: () => dispatch(doSentLinkVerificationEmail()),
    refreshToken: () => dispatch(doRefreshToken()),
    fetchProfile: () => dispatch(doFetchProfile()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalUnverifiedUser);
